/**
 * Permission string constants (no imports — safe for nav config & utilities).
 */
export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard_view',
  DASHBOARD: 'dashboard',

  ANALYTICS_VIEW: 'analytics_view',
  ANALYTICS: 'analytics',

  CLIENTS_VIEW: 'clients_view',
  CLIENTS: 'clients',
  CLIENTS_VIEW_DETAILS: 'clients_view_details',
  CLIENTS_EXPORT: 'clients_export',
  CLIENTS_EDIT_ADDRESS: 'update_address',

  AFFILIATES_VIEW: 'affiliates_view',
  AFFILIATES: 'affiliates',
  AFFILIATES_VIEW_DETAILS: 'affiliates_view_details',
  AFFILIATES_MANAGE_TYPE: 'affiliates_manage_type',
  AFFILIATES_SUPER_VIEW: 'affiliates_super_view',
  AFFILIATES_ADD_WALLET: 'affiliates_add_wallet',
  AFFILIATES_EXPORT: 'affiliates_export',
  AFFILIATES_UPDATE_COMMISSION: 'affiliates_update_commission',

  RECRUITER_MEETINGS_VIEW: 'recruiter_meetings_view',
  RECRUITER_MEETINGS: 'recruiter_meetings',

  REFERRALS_VIEW: 'referrals_view',
  REFERRALS: 'referrals',
  REFERRALS_CODES: 'referrals_codes',
  REFERRALS_UPLOAD: 'referrals_upload',
  REFERRAL_ASSIGN_PERMISSION: 'referral_assign_permission',
  AFFILIATE_REFERRAL_ASSIGN_PERMISSION: 'Affiliate_referral_assign_permission',

  REFERRAL_REQUESTS_VIEW: 'referral_requests_view',
  REFERRAL_REQUESTS: 'referral_requests',
  REFERRAL_REQUESTS_VIEW_DETAILS: 'referral_requests_view_details',
  REFERRAL_REQUESTS_APPROVE: 'referral_requests_approve',
  REFERRAL_REQUESTS_REJECT: 'referral_requests_reject',

  PAYOUTS_VIEW: 'payouts_view',
  PAYOUTS: 'payouts',

  REFUND_INVOICES_VIEW: 'refund_invoices_view',

  EXEMPTIONS_VIEW: 'exemptions_view',
  EXEMPTIONS_VIEW_DETAILS: 'exemptions_view_details',
  PROTESTS_EXEMPTIONS: 'protests_exemptions',

  PROTESTS_VIEW: 'protests_view',
  PROTESTS_VIEW_DETAILS: 'protests_view_details',
  PROTESTS_APPROVE: 'protests_approve',
  PROTESTS_REJECT: 'protests_reject',
  PROTESTS_IN_PROGRESS: 'protests_in_progress',
  UPLOAD_SETTLEMENT_WAIVER_DOCUMENT: 'upload_settlement_waiver_document',
  UPDATE_ASSESSED_VALUES_PERMISSION: 'update_assessed_values_permission',

  ROLES_VIEW: 'roles_view',
  ROLES_PERMISSIONS: 'roles_permissions',
  ROLES_CREATE: 'roles_create',
  ROLES_UPDATE: 'roles_update',
  ROLES_DELETE: 'roles_delete',
  ROLES_ASSIGN_PERMISSIONS: 'roles_assign_permissions',

  NOTIFICATIONS_VIEW: 'notifications_view',
  NOTIFICATIONS_VIEW_DETAILS: 'notifications_view_details',
  NOTIFICATIONS_CREATE: 'notifications_create',
  NOTIFICATIONS_SEND: 'notifications_send',
  PUSH_NOTIFICATIONS: 'push_notifications',

  CLIENT_INBOX_VIEW: 'client_inbox_view',
  CLIENT_INBOX_SEND: 'client_inbox_send',
  AFFILIATE_INBOX_VIEW: 'affiliate_inbox_view',
  AFFILIATE_INBOX: 'affiliate_inbox',
  AFFILIATE_INBOX_SEND: 'affiliate_inbox_send',

  APP_VERSION_VIEW: 'app_version_view',
  APP_VERSION: 'app_version',
  APP_VERSION_UPDATE: 'app_version_update',

  COUPONS_VIEW: 'coupons_view',
  COUPONS: 'coupons',
  COUPONS_CREATE: 'coupons_create',
  COUPONS_UPDATE: 'coupons_update',
  COUPONS_DELETE: 'coupons_delete',
  COUPONS_TOGGLE: 'coupons_toggle',

  TRAINING_VIEW: 'training_view',
  TRAINING: 'training',
  TRAINING_CREATE: 'training_create',
  TRAINING_UPDATE: 'training_update',
  TRAINING_DELETE: 'training_delete',
  TRAINING_LIBRARY: 'training_library',
  TRAINING_TOGGLE: 'training_toggle',
  TRAINING_VIDEOS: 'training_videos',
  TRAINING_PDFS: 'training_pdfs',
  TRAINING_LINKS: 'training_links',
  TRAINING_ALL: 'training_all',

  CAMPAIGN_VIEW: 'campaign_view',
  CAMPAIGN: 'campaign',

  CAMPAIGN_LEADS_VIEW: 'campaign_leads_view',
  CAMPAIGN_LEADS: 'campaign_leads',

  WALLET_VIEW: 'wallet_view',
  WALLET_VIEW_HISTORY: 'wallet_view_history',
  WALLET_ADD_CREDIT: 'wallet_add_credit',
  WALLET_MANAGEMENT: 'wallet_management',

  USER_STATUS_UPDATE: 'user_status_update',
  USER_STATUS_MANAGEMENT: 'user_status_management',
  USER_FORCE_MOBILE_UPDATE: 'user_force_mobile_update',
  USER_FORCE_PASSWORD_UPDATE: 'user_force_password_update', // NOSONAR - permission key, not a credential
  USER_SEND_WELCOME_MESSAGE: 'user_send_welcome_message',
  AFFILIATES_SEND_WELCOME_MESSAGE: 'affiliates_send_welcome_message',
  AFFILIATES_STATUS_UPDATE: 'affiliates_status_update',
  AFFILIATES_FORCE_PASSWORD_UPDATE: 'affiliates_force_password_update', // NOSONAR - permission key, not a credential
  AFFILIATES_FORCE_MOBILE_UPDATE: 'affiliates_force_mobile_update',

  PROPERTY_PROVISIONING: 'campaign_property_provision',
  SUPERADMIN_CLIENTS_VIEW: 'superadmin_clients_view',
  HOMESTEAD: 'homestead',
  GRAFANA: 'grafana',

  PROPERTY_REPORT_VIEW: 'property_report_view',
  PROPERTY_REPORT: 'property_report',

  ESTIMATE_REQUEST_VIEW: 'estimate_request_view',
  ESTIMATE_REQUEST_ADD: 'estimate_request_add',
  ESTIMATE_REQUEST: 'estimate_request',

  CMS_MANAGE: 'cms_manage',

  CMS_AUTHORS_VIEW: 'cms_authors_view',
  CMS_AUTHORS_CREATE: 'cms_authors_create',
  CMS_AUTHORS_UPDATE: 'cms_authors_update',
  CMS_AUTHORS_DELETE: 'cms_authors_delete',

  CMS_TAXONOMY_VIEW: 'cms_taxonomy_view',
  CMS_TAXONOMY_MANAGE: 'cms_taxonomy_manage',

  CMS_BLOGS_VIEW: 'cms_blogs_view',
  CMS_BLOGS_CREATE: 'cms_blogs_create',
  CMS_BLOGS_UPDATE: 'cms_blogs_update',
  CMS_BLOGS_PUBLISH: 'cms_blogs_publish',
  CMS_BLOGS_DELETE: 'cms_blogs_delete',

  CMS_FAQS_VIEW: 'cms_faqs_view',
  CMS_FAQS_CREATE: 'cms_faqs_create',
  CMS_FAQS_UPDATE: 'cms_faqs_update',
  CMS_FAQS_DELETE: 'cms_faqs_delete',

  CMS_NEWS_VIEW: 'cms_news_view',
  CMS_NEWS_CREATE: 'cms_news_create',
  CMS_NEWS_UPDATE: 'cms_news_update',
  CMS_NEWS_PUBLISH: 'cms_news_publish',
  CMS_NEWS_DELETE: 'cms_news_delete',

  CMS_MEDIA_VIEW: 'cms_media_view',
  CMS_MEDIA_UPLOAD: 'cms_media_upload',
  CMS_MEDIA_DELETE: 'cms_media_delete',

  CMS_SUBSCRIBERS_VIEW: 'cms_subscribers_view',
  CMS_SUBSCRIBERS_MANAGE: 'cms_subscribers_manage',

  PARTNERS_VIEW: 'partners_view',
  PARTNERS_CREATE: 'partners_create',
  PARTNERS_UPDATE: 'partners_update',
  PARTNERS_ROTATE_KEY: 'partners_rotate_key',
  PARTNERS_STATUS_UPDATE: 'partners_status_update',
};


